import ChangeDown from "./general/downs/change-down";
import FirstDown from "./general/downs/first-down";
import FirstDownFlag from "./general/downs/flag-first-down";
import PlayEnd from "./general/play-end";
import PlayEndDown from "./general/play-end-down";
import GameStart from "./general/game-start";
import Timeout from "./general/timeout";
import Touchdown from "./general/scoring/touchdown";
import NoRecoveryKickReturn from "./general/kicks/no-recovery-kick-return";
import FieldGoalFakePassAttemptStats from "./general/kicks/fieldgoal/field-goal-fake-pass-attempt-stats";
import FieldGoalFakeRunFieldChange from "./general/kicks/fieldgoal/field-goal-fake-run-field-change";
import FieldGoalFakeRunStats from "./general/kicks/fieldgoal/field-goal-fake-run-stats";
import FieldGoalFakeRunTouchdownStats from "./general/kicks/fieldgoal/field-goal-fake-run-touchdown-stats";
import FieldGoalBlockedRecovery from "./general/kicks/fieldgoal/field-goal-blocked-recovery";
import FieldGoalFumbleNoRecovery from "./general/kicks/fieldgoal/field-goal-fumble-no-recovery";
import FieldGoalGood from "./general/kicks/fieldgoal/field-goal-good";
import FieldGoalMissed from "./general/kicks/fieldgoal/field-goal-missed";
import FieldGoalStats from "./general/kicks/fieldgoal/field-goal-stats";
import FieldGoalBlockedStats from "./general/kicks/fieldgoal/field-goal-blocked-stats";
import FieldGoalGoodNotAffectedByPenalty from "./general/kicks/fieldgoal/field-goal-good-not-affected-by-penalty";
import FieldGoalOutOfBounds from "./general/kicks/fieldgoal/field-goal-out-of-bounds";
import KickOff from "./general/kick-off";
import KickOffStats from "./general/kicks/kickoff/kick-off-stats";
import KickOffReturnStats from "./general/kicks/kickoff-return/kickoff-return-stats";
import KickOffPenaltyAccepted from "./general/kicks/kickoff/kick-off-penalty-accepted";
import KickOffPenaltyDeclined from "./general/kicks/kickoff/kick-off-penalty-declined";
import FairCatch from "./general/fair-catch";
import Returned from "./general/returned";
import OutofBoundsStats from "./defensive/out-of-bounds/out-of-bounds-stats";
import PatComplete from "./general/scoring/pat-complete";
import PatTurnoverPointsAwarded from "./general/scoring/pat-turnover-points-awarded";
import PatKickStats from "./offensive/pat/pat-kick-stats";
import PatTry from "./offensive/pat/pat-try";
import PatRun from "./offensive/pat/pat-run";
import PatPass from "./offensive/pat/pat-pass";
import Continued from "./offensive/continued";
import PassAttemptStats from "./offensive/pass/attempt/pass-attempt-stats";
import PassCompleteStatsTouchdown from "./offensive/pass/complete/pass-complete-touchdown-stats";
import PassCompleteFieldChange from "./offensive/pass/complete/field-change";
import PassIncompleteStats from "./offensive/pass/incomplete/pass-incomplete-stats";
import PassSackedStats from "./offensive/pass/sack/pass-sack-stats";
import PassSackFieldChange from "./offensive/pass/sack/field-change";
import PassInterceptionStats from "./offensive/pass/interception/pass-interception-stats";
import PassInterceptionFieldChange from "./offensive/pass/interception/field-change";
import PassInterceptionStatsTouchdown from "./offensive/pass/interception/pass-interception-touchdown-stats";
import RushStats from "./offensive/rush/rush-stats";
import RushFieldChange from "./offensive/rush/rush-field-change";
import TackleStats from "./defensive/tackle/tackle-stats";
import ResetField from "./general/reset-field";
import SpikeStats from "./offensive/spike-stats";

//Special Teams
import PuntStatsPunter from "./specialteams/punt/punter-stats";
import PuntFieldChangeNoReturn from "./specialteams/punt/no-return/field-change";
import PuntFieldChangeReturn from "./specialteams/punt/return/field-change";
import PuntReturnerStats from "./specialteams/punt/return/punt-returner-stats";
import PuntTouchbackStatsPunter from "./specialteams/punt/touchback/touchback-punter-stats";
import PatFail from "./offensive/pat/pat-fail";
import AddToDrive from "./general/drives/add-to-drive";
import EndDrive from "./general/drives/end-drive";
import CreateDrive from "./general/drives/create-drive";
import SetTimeOnPlay from "./general/set-time-on-play";
import PenaltyAccepted from "./general/penalty/penalty-accepted";
import UpdateContext from "./general/update-context";
import SetTimeAndPeriod from "./general/set-time-and-period";
import PeriodStart from "./general/period-start";
import CoinToss from "./general/coin-toss";
import Turnover from "./general/turnover";

import PuntBlockedStats from "./specialteams/punt/blocked/punt-blocked-stats";
import Onside from "./general/kicks/onside";
import FumbleRecoveryStats from "./offensive/fumble/fumble-recovery-stats";
import SafetyRecordStats from "./defensive/safety/safety-stats";
import StartKickOff from "./general/start-kick-off";
import SecondHalfPossessionSwitch from "./general/second-half-poss-switch";
import NextKickOff from "./general/next-kickoff";
import FumbleRecovery from "./offensive/fumble/fumble-recovery";
import PenaltyAcceptedStats from "./general/penalty/penalty-accepted-stats";
import PatCompleteStats from "./general/scoring/pat-complete-stats";
import AwardFirstDown from "./general/downs/award-first-down";
import ChangeDownStats from "./general/downs/change-down-stats";
import CountTouchdownsAsFirstDownsRule from "./general/downs/count-touchdowns-as-first-downs-rule";
import ContinuedStats from "./offensive/continued-stats";
import LateralStats from "./offensive/lateral-stats";
import PatPassStats from "./offensive/pat/pat-pass-stats";
import PatRunStats from "./offensive/pat/pat-run-stats";
import QuarterbackStats from "./offensive/pass/complete/quarterback-stats";
import PassCompleteReceiverStats from "./offensive/pass/complete/pass-complete-receiver-stats";
import FumbleStats from "./offensive/fumble/fumble-stats";
import RushTouchdownStats from "./offensive/rush/rush-touchdown-stats";
import PuntReturnTouchdownStats from "./specialteams/punt/return/punt-return-touchdown-stats";
import Safety from "./defensive/safety/safety";
import SafetyPunt from "./defensive/safety/safety-punt";
import PuntBlockedRecovery from "./specialteams/punt/blocked/punt-blocked-recovery";
import PuntNoRecoveryReturnerStats from "./specialteams/punt/return/punt-no-recovery-returner-stats";
import Lateral from "./offensive/lateral";
import Pass from "./offensive/pass/pass";
import FumbleRecoveryTouchdownStats from "./offensive/fumble/fumble-recovery-touchdown-stats";
import CollectDriveTime from "./general/drives/collect-drive-time";
import FairCatchTouchback from "./general/fair-catch-touchback";
import Rouge from "./general/kicks/rouge";
import KneelDownStats from "./offensive/kneeldown-stats";
import KneelDown from "./offensive/kneeldown";
import TouchBack from "./general/touchback";
import PatFieldSetup from "./offensive/pat/pat-field-setup";
import PatDefenseComplete from "./general/scoring/pat-defense-complete";
import IsPatGameRule from "./general/is-pat-game-rule";
import IsRegularGameRule from "./general/is-regular-game-rule";
import CollectStatsOnPatRule from "./stats/collect-stats-on-pat-rule";
import PatDefenseCompleteStats from "./general/scoring/pat-defense-complete-stats";
import StartGame from "./general/start-game";
import SkipKickoff from "./general/skip-kickoff";
import FumbleSnapStats from "./offensive/fumble/fumble-snap-stats";
import SwapTeams from "./general/swap-teams";
import KickOffOutOfBounds from "./general/kicks/kickoff/kick-off-out-of-bounds";
import UpdateContextStats from "./general/update-context-stats";
import TouchdownStats from "./offensive/touchdown-stats";
import ContinueTouchdownStats from "./offensive/continue-touchdown-stats";
import Finalize from "./general/finalize";
import MissedFieldGoalReturnStats from "./specialteams/punt/return/missed-field-goal-return-stats";

const FootballRules = Object.freeze({
    General: Object.freeze({
        KickOff: new KickOff(),
        Kicks: Object.freeze({
            Onside: new Onside(),
            RecordStatsKickOff: new KickOffStats(),
            RecordStatsKickOffReturn: new KickOffReturnStats(),
            KickOffPenaltyAccepted: new KickOffPenaltyAccepted(),
            KickOffPenaltyDeclined: new KickOffPenaltyDeclined(),
            KickOffOutOfBounds: new KickOffOutOfBounds(),
            FieldGoalFakeRunFieldChange: new FieldGoalFakeRunFieldChange(),
            RecordStatsFakeRun: new FieldGoalFakeRunStats(),
            RecordStatsFakeRunTouchdown: new FieldGoalFakeRunTouchdownStats(),
            RecordStatsFakePassAttempt: new FieldGoalFakePassAttemptStats(),
            FieldGoalBlockedRecovery: new FieldGoalBlockedRecovery(),
            FieldGoalFumbleNoRecovery: new FieldGoalFumbleNoRecovery(),
            FieldGoalGood: new FieldGoalGood(),
            FieldGoalMissed: new FieldGoalMissed(),
            FieldGoalGoodNotAffectedByPenalty:
                new FieldGoalGoodNotAffectedByPenalty(),
            FieldGoalOutOfBounds: new FieldGoalOutOfBounds(),
            RecordStatsFieldGoal: new FieldGoalStats(),
            RecordStatsFieldGoalBlocked: new FieldGoalBlockedStats(),
            NoRecoveryKickReturn: new NoRecoveryKickReturn(),
            Rouge: new Rouge()
        }),
        FairCatch: new FairCatch(),
        FairCatchTouchback: new FairCatchTouchback(),
        Returned: new Returned(),
        PlayEnd: Object.freeze({
            Default: new PlayEnd(),
            Down: new PlayEndDown()
        }),
        Finalize: new Finalize(),
        AwardFirstDown: new AwardFirstDown(),
        ChangeDownStats: new ChangeDownStats(),
        CountTouchdownsAsFirstDowns: new CountTouchdownsAsFirstDownsRule(),
        ChangeDown: new ChangeDown(),
        FirstDown: new FirstDown(),
        FlagFirstDown: new FirstDownFlag(),
        SetTimeOnPlay: new SetTimeOnPlay(),
        StartGame: new StartGame(),
        Drive: Object.freeze({
            AddPlay: new AddToDrive(),
            Create: new CreateDrive(),
            CollectTime: new CollectDriveTime(),
            EndDrive: new EndDrive()
        }),
        Scoring: Object.freeze({
            Touchdown: new Touchdown(),
            Pat: Object.freeze({
                Try: new PatTry(),
                Complete: new PatComplete(),
                DefenseComplete: new PatDefenseComplete(),
                CompleteStats: new PatCompleteStats(),
                DefenseCompleteStats: new PatDefenseCompleteStats(),
                Run: new PatRun(),
                RunStats: new PatRunStats(),
                Pass: new PatPass(),
                PassStats: new PatPassStats(),
                KickStats: new PatKickStats(),
                Fail: new PatFail(),
                TurnoverPointsAwarded: new PatTurnoverPointsAwarded(),
                FieldSetup: new PatFieldSetup()
            })
        }),
        SkipKickoff: new SkipKickoff(),
        ResetField: new ResetField(),
        SecondHalfPossessionSwitch: new SecondHalfPossessionSwitch(),
        NextKickOff: new NextKickOff(),
        GameStart: new GameStart(),
        StartKickOff: new StartKickOff(),
        Timeout: new Timeout(),
        UpdateContext: new UpdateContext(),
        UpdateContextStats: new UpdateContextStats(),
        SwapTeams: new SwapTeams(),
        SetTimeAndPeriod: new SetTimeAndPeriod(),
        Penalty: Object.freeze({
            Accepted: new PenaltyAccepted(),
            AcceptedStats: new PenaltyAcceptedStats()
        }),
        StartPeriod: new PeriodStart(),
        CoinToss: new CoinToss(),
        Turnover: new Turnover(),
        TouchBack: new TouchBack(),
        IsRegularGame: new IsRegularGameRule(),
        IsPatGame: new IsPatGameRule(),
        CollectStatsOnPat: new CollectStatsOnPatRule()
    }),
    Offensive: Object.freeze({
        Continued: new Continued(),
        ContinuedStats: new ContinuedStats(),
        Fumble: Object.freeze({
            RecordStats: new FumbleStats(),
            Recovery: new FumbleRecovery(),
            RecoveryStats: new FumbleRecoveryStats(),
            RecordStatsTouchdown: new FumbleRecoveryTouchdownStats(),
            SnapStats: new FumbleSnapStats()
        }),
        Pass: Object.freeze({
            Pass: new Pass(),
            Attempt: Object.freeze({
                RecordStats: new PassAttemptStats()
            }),
            Complete: Object.freeze({
                RecordStatsReceiver: new PassCompleteReceiverStats(),
                FieldChange: new PassCompleteFieldChange(),
                RecordStatsQuarterback: new QuarterbackStats(),
                RecordStatsTouchdown: new PassCompleteStatsTouchdown()
            }),
            Incomplete: Object.freeze({
                RecordStats: new PassIncompleteStats()
            }),
            Interception: Object.freeze({
                RecordStats: new PassInterceptionStats(),
                FieldChange: new PassInterceptionFieldChange(),
                RecordStatsTouchdown: new PassInterceptionStatsTouchdown()
            }),
            Sacked: Object.freeze({
                RecordStats: new PassSackedStats(),
                FieldChange: new PassSackFieldChange()
            })
        }),
        SpikeStats: new SpikeStats(),
        Rush: Object.freeze({
            RecordStats: new RushStats(),
            FieldChange: new RushFieldChange(),
            RecordStatsTouchdown: new RushTouchdownStats(),
            ContinueTouchdownStats: new ContinueTouchdownStats()
        }),
        Lateral: new Lateral(),
        LateralStats: new LateralStats(),
        KneelDownStats: new KneelDownStats(),
        KneelDown: new KneelDown(),
        TouchdownStats: new TouchdownStats()
    }),
    Defensive: Object.freeze({
        Tackle: Object.freeze({
            RecordStats: new TackleStats()
        }),
        OutOfBounds: Object.freeze({
            RecordStats: new OutofBoundsStats()
        }),
        Safety: Object.freeze({
            Punt: new SafetyPunt(),
            Complete: new Safety(),
            RecordStats: new SafetyRecordStats()
        })
    }),
    SpecialTeams: Object.freeze({
        Punt: Object.freeze({
            RecordStatsPunter: new PuntStatsPunter(),
            NoReturn: Object.freeze({
                FieldChange: new PuntFieldChangeNoReturn()
            }),
            Return: Object.freeze({
                FieldChange: new PuntFieldChangeReturn(),
                RecordStats: new PuntReturnerStats(),
                RecordStatsTouchdown: new PuntReturnTouchdownStats(),
                PuntNoRecoveryReturnerStats: new PuntNoRecoveryReturnerStats(),
                RecordStatsFg: new MissedFieldGoalReturnStats()
            }),
            TouchBack: Object.freeze({
                RecordStats: new PuntTouchbackStatsPunter()
            }),
            Blocked: Object.freeze({
                Recovery: new PuntBlockedRecovery(),
                RecordStats: new PuntBlockedStats()
            })
        })
    })
});

export default FootballRules;
